import { createRouter, createWebHistory } from 'vue-router';
import Entry from '../views/EntryPage.vue';
import Home from '../views/HomePage.vue';
import Meeting from '../views/MeetingDetails.vue';
import Service from '../views/ServiceCenter.vue';
import Seats from '../views/SeatQuery.vue';
import Apply from '../views/ApplyPage.vue';
import Invitation from '../views/InvitationPage.vue';
import Hotel from '../views/HotelPage.vue';
import Dining from '../views/DiningPage.vue';
import Tip from '../views/TipsPage.vue';
import SignIn from '../views/SignIn.vue';
import SceneUp from '../views/SceneUp.vue';
import Check from '../views/CheckPage.vue';

const routes = [
  { path: '/', name: 'entry', component: Entry },
  { path: '/home', name: 'home', component: Home },
  { path: '/meeting', name: 'meeting', component: Meeting },
  { path: '/invitation', name: 'invitation', component: Invitation },
  { path: '/service', name: 'service', component: Service },
  { path: '/seats', name: 'seats', component: Seats },
  { path: '/apply', name: 'apply', component: Apply },
  { path: '/hotel', name: 'hotel', component: Hotel },
  { path: '/dining', name: 'dining', component: Dining },
  { path: '/tip', name: 'tip', component: Tip },
  { path: '/signin', name: 'signin', component: SignIn },
  { path: '/sceneUp', name: 'sceneUp', component: SceneUp },
  { path: '/check', name: 'check', component: Check }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;